import { render } from "./EffectBlock.vue?vue&type=template&id=58d7930c&ts=true"
import script from "./EffectBlock.vue?vue&type=script&lang=ts"
export * from "./EffectBlock.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__